import cx from 'classnames';

import { ReviewRating, ReviewRatingProps } from '../../review/rating/ReviewRating';

import style from './TripReviewCard.module.css';

type Props = {
    creationDate: string;
    creationDateFormatted: string;
    onClickTripReview: () => void;
    reviewRatingProps: ReviewRatingProps;
    seeMoreLabel: string;
    travelerName: string | null;
    tripDescription: string | null;
};

export function TripReviewCard({
    creationDate,
    creationDateFormatted,
    onClickTripReview,
    reviewRatingProps,
    seeMoreLabel,
    travelerName,
    tripDescription,
}: Props) {
    return (
        <div className={style.tripReviewCard}>
            {travelerName ? <div className={style.travelerName}>{travelerName}</div> : null}
            <ReviewRating {...reviewRatingProps} className={style.reviewRating} showRatingNumber />
            <time className={style.creationDate} dateTime={creationDate}>
                {creationDateFormatted}
            </time>
            <div className={style.tripDescription}>{tripDescription}</div>
            <span
                onClick={onClickTripReview}
                className={cx(style.seeMore, 'link', 'font-body-bold')}
            >
                {seeMoreLabel}
            </span>
        </div>
    );
}
